import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0d0804] text-gray-400 py-10 px-4 text-center text-sm" data-id="element-72">
      <div className="font-display font-bold text-white text-lg mb-2" data-id="element-73">
        🎸 Guitarra Fácil PRO™
      </div>
      <p className="mb-6 max-w-xs mx-auto" data-id="element-74">
        El método N°1 para aprender guitarra de forma progresiva, práctica y
        pensada para principiantes en Argentina.
      </p>

      <div className="flex justify-center items-center gap-2 mb-6 text-xs" data-id="element-75">
        <span data-id="element-76">📧 hola@guitarrafacil.com</span>
        <span data-id="element-77">·</span>
        <span data-id="element-78">📱 @guitarrafacilpro</span>
        <span data-id="element-79">·</span>
        <span data-id="element-80">🌐 guitarrafacil.com</span>
      </div>

      <div className="text-xs mb-4" data-id="element-81">
        © Guitarra Fácil PRO™ 2026 — Todos los derechos reservados.
      </div>

      <div className="font-medium text-gray-500 italic" data-id="element-82">
        🎸 "De cero a tu primera canción."
      </div>
    </footer>;
}